import React from 'react'
import { CodeSnippet, CodeSnippetProps } from './code-snippet'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

export function AttackExampleCodeSnippet(props: CodeSnippetProps) {
  return (
    <CodeSnippet
      {...{
        className: css`
          border: 1px solid ${theme.color.neutral40};
          border-radius: 5px;
        `,
        ...props
      }}
    />
  )
}
